module.exports = __webpack_public_path__ + "img/Group-278.f7a7273c.png";